import { render } from "./InformationCalendarSyncPopup.vue?vue&type=template&id=d5b30a22&ts=true"
import script from "./InformationCalendarSyncPopup.vue?vue&type=script&lang=ts"
export * from "./InformationCalendarSyncPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__